/* eslint-disable @typescript-eslint/semi */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */


/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { Module ,Node} from '@msdyn365-commerce-modules/utilities';
import {Image } from '@msdyn365-commerce/core';

import { IMfrmReasonsToBuyViewProps } from './mfrm-reasons-to-buy';
const MfrmReasonsToBuyView: React.FC<IMfrmReasonsToBuyViewProps> = props => {
    const { reasonToBuyData } = props;
    if (!reasonToBuyData) {
        props.context.telemetry.error('Value props RTB block is empty, module wont render.');
        return null;
    }
    return (reasonToBuyData && _renderReasonToBuy(props));
};

const _renderReasonToBuy = (props: IMfrmReasonsToBuyViewProps): JSX.Element | null => {
    const { reasonToBuyData, reasonsToBuyContainer } = props;
    const gridSettings =props.context.request.gridSettings;
    if (reasonToBuyData  && reasonToBuyData.length > 0) {
        return (
            <Module {...reasonsToBuyContainer} className='reason-to-buy-container'>
                <Node className="reason-to-buy__header-text">
                    <h2>{props.config.reasonsToBuyHeaderText}</h2>
                </Node>
                {
                    reasonToBuyData.map((reasonToBuy, index) => (
                    <Node key={index} className='reason-to-buy__item'>
                       <Node  className='reason-to-buy__image'>
                       <Image
                            src={`${reasonToBuy.icon}`}
                            alt={`${reasonToBuy.heading} icon`}
                            gridSettings={gridSettings!}
                            />
                       </Node>
                        <Node className='reason-to-buy__detail'>
                            <Node tag="h4" className='reason-to-buy__title'>{reasonToBuy.heading}</Node>
                            <Node className='reason-to-buy__description'>
                                <p>{reasonToBuy.description}</p>
                            </Node>
                        </Node>
                    </Node>
                      ))
                }
            </Module>
        );
    }
    return null;
};

export default MfrmReasonsToBuyView;

